const options = {
  OPTION_BLOCK: { value: 'Toont titels', label: 'Gebruik als los data blok in de offerte (met titel)' },
  OPTION_INPUT: { value: 'Toont titels niet', label: 'Gebruik als veld input in de offerte (zonder titel)' },
};

export default options;

export const groupOptions = Object.entries(options)
  .map(entry => entry[1]);